import _ from 'lodash';
import React, { Component } from 'react';
import { connect } from 'react-redux';

import ReactTooltip from 'react-tooltip';

import { CopyToClipboard } from 'react-copy-to-clipboard';

import {
  AssessmentVersionsRef,
  AssessmentsRef,
  PublicUsersRef,
} from '../../../util/refs';

import {
  getIcon,
  getOptionValueForSelect,
  unwrapDoc,
  unwrapDocs,
  excludeTestAssessments,
  getCategoryFromDimensionId,
} from '../../../util';

import { Switch } from '../../shared';

import {
  getDimensionScores
} from '../../../util/data';

import { talentProfiles } from '../../../data/talentProfiles';
import { dimensions } from '../../../data/dimensions';

import {
  scoreAssessmentForExport
} from '../../../util/assessmentScoring';

import {
  fetchAssessmentConfigs
} from '../../../actions/admin';

import Select from 'react-select';

const TALENT_CATEGORIES = [{
  name: 'Motivation',
  id: '1',
},{
  name: 'Interaction',
  id: '2',
},{
  name: 'Cognition',
  id: '3',
}, {
  name: 'Execution',
  id: '4'
}];

class AssessmentResultsExportTool extends Component{

  state = {
    assessmentConfigs: null,
    selectedAssessment: null,
    selectedTalentProfile: null,
    includeOtherProfileAssessments: false,
    reportCSV: null,
    userData: null,
    preparingReport: false,
    recentlyCopied: false,
    deprecatedScoring: false,
  }

  componentDidMount(){
    fetchAssessmentConfigs(assessmentConfigs => {
      this.setState({
        assessmentConfigs
      });
    })
  }

  componentDidUpdate(prevProps, prevState){
    if(prevState.selectedAssessment !== this.state.selectedAssessment){
      this.setState({
        selectedTalentProfile: null,
        reportCSV: null,
        includeOtherProfileAssessments: false,
      });
    }
     else if( prevState.selectedTalentProfile !== this.state.selectedTalentProfile ||
              prevState.includeOtherProfileAssessments !== this.state.includeOtherProfileAssessments ||
              prevState.deprecatedScoring !== this.state.deprecatedScoring
    ){
       this.setState({
         reportCSV: null,
       });
     }
  }

  currentlySelectedAssessment(){
    return _.find(this.state.assessmentConfigs || [], { _id: this.state.selectedAssessment }) || null;
  }

  renderAssessmentConfigSelect(){
    if(!this.state.assessmentConfigs){
      return 'Loading...'
    }

    const assessmentConfigOptions = _.map(this.state.assessmentConfigs, config => {
      return {
        label: config.name,
        value: config._id
      }
    });

    return (
      <Select
        placeholder="Select an Assessment..."
        classNamePrefix={'react-select'}
        className='react-select-container reports-require-role'
        value={getOptionValueForSelect(assessmentConfigOptions, this.state.selectedAssessment)}
        options={assessmentConfigOptions}
        onChange={(option) => { this.setState({ selectedAssessment: option.value }); }}
        isSearchable={false}
      />
    )
  }

  renderAssessmentProfileSelect(){

    const assessmentProfileOptions = _.map(this.currentlySelectedAssessment().profileNames, (id, name) => {
      return {
        label: name,
        value: id
      }
    });

    return (
      <Select
        placeholder="Select a Talent Profile..."
        classNamePrefix={'react-select'}
        className='react-select-container reports-require-role'
        value={getOptionValueForSelect(assessmentProfileOptions, this.state.selectedTalentProfile)}
        options={assessmentProfileOptions}
        onChange={(option) => { this.setState({ selectedTalentProfile: option.value }); }}
        isSearchable={false}
      />
    )
  }

  renderAssessmentConfigOption(){
    return (
      <div className="export-option">
        <div className="export-option-label">Assessment</div>
        <div className="export-option-value">
          {this.renderAssessmentConfigSelect()}
        </div>
      </div>
    )
  }

  renderDeprecatedScoringOption(){

    const {
      deprecatedScoring
    } = this.state;

    return (
      <div className="export-option">
        <div className="export-option-label">Use Deprecated Scoring</div>
        <div className="export-option-value">
        <Switch
          id="enable-deprecated-scoring"
          checked={deprecatedScoring || false}
          onChange={checked => { this.setState({ deprecatedScoring: checked }); } }
        />
        </div>
      </div>
    )
  }

  renderIncludeAssessmentsFromOtherProfilesSelect(){

    const options = [{
      label: `Only this profile (${this.state.selectedTalentProfile})`,
      value: false
    },{
      label: 'Include all profiles',
      value: true
    }];

    return (
      <Select
        placeholder="..."
        classNamePrefix={'react-select'}
        className='react-select-container reports-require-role'
        value={getOptionValueForSelect(options, this.state.includeOtherProfileAssessments)}
        options={options}
        onChange={(option) => { this.setState({ includeOtherProfileAssessments: option.value }); }}
        isSearchable={false}
      />
    )
  }

  renderExportDataOptions(){

    const {
      selectedTalentProfile
    } = this.state

    return (
      <React.Fragment>
        <div className="export-option">
          <div className="export-option-label">Profile</div>
          <div className="export-option-value">
            {this.renderAssessmentProfileSelect()}
          </div>
        </div>
        {selectedTalentProfile &&
          <div className="export-option">
            <div className="export-option-label">Include assessment data from...</div>
            <div className="export-option-value">
              {this.renderIncludeAssessmentsFromOtherProfilesSelect()}
            </div>
          </div>
        }
      </React.Fragment>
    )
  }

  currentlySelectedTalentProfile(){
    if(!this.state.selectedTalentProfile){
      return null;
    }

    return talentProfiles[this.state.selectedTalentProfile];
  }

  getDimensionLabel(dimensionId){
    //todo get localized version of this if need be!
    return dimensions[dimensionId].label;
  }

  mapAssessmentScoresToCSV(assessmentScores, userData){

    console.log('mapping assessment scores to csv for assessment scores: ', assessmentScores);

    let assessmentScoresAsCSV = '';

    const dimensionsScoredForProfile = this.currentlySelectedTalentProfile().scoredDimensions;

    const dimensionsColumns = _.map(dimensionsScoredForProfile, dimensionId => {
      const dimensionLabel = this.getDimensionLabel(dimensionId);
      return `${dimensionLabel} Playbook Percent,${dimensionLabel} Items,${dimensionLabel} Score Possible,${dimensionLabel} User Score,${dimensionLabel} Adjusted Score,${dimensionLabel} Percent of Total`
    });

    const categoryColumns = _.join(_.map(TALENT_CATEGORIES, category => {
      return `${category.name} Adjusted Percent`;
    }), ',');

    const firstRowForCSV = `User,Total Items,Total Score Possible,Total User Score,${categoryColumns},${dimensionsColumns.join(',')}`;

    assessmentScoresAsCSV += firstRowForCSV;

    let userRowsData = [];

    _.each(assessmentScores, userAssessment => {

      let dimensionScoresRowPart = '';

      let scoreDataByDimension = {};

      _.each(dimensionsScoredForProfile, dimensionId => {

        const userScoresForDimension = userAssessment.dimensionScores[dimensionId];

        const dimensionItems = userScoresForDimension.count;
        const dimensionTotalPossible = dimensionItems * 7;
        const dimensionUserScore = userScoresForDimension.total;
        const dimensionAdjustedScore = (dimensionUserScore / dimensionItems) * 14.;
        const dimensionPercentOfTotal = (dimensionUserScore / dimensionTotalPossible);

        scoreDataByDimension[dimensionId] = {
          dimensionItems,
          dimensionTotalPossible,
          dimensionUserScore,
          dimensionAdjustedScore,
          dimensionPercentOfTotal,
        }
      });

      //get category scores
      // const orderedDimensionScoresWithCategories = getDimensionScores(_.mapValues(userAssessment.dimensionScores, 'adjusted'));
      // console.log('userAssessment.dimensionScores: ', userAssessment.dimensionScores);
      // console.log('orderedDimensionScoresWithCategories: ', orderedDimensionScoresWithCategories);

      userRowsData.push({
        userId: userAssessment.user,
        userData: _.find(userData, { _id: userAssessment.user }),
        fitScore: userAssessment.fitData.score,
        totalItems: userAssessment.fitData.items,
        totalScorePossible: userAssessment.fitData.totalPossible,
        scoreDataByDimension,
        categoryScores: userAssessment.categoryScores
      });
    });

    //add user rows by sorted order of total score achieved
    const sortedUserRowData = _.orderBy(userRowsData, 'fitScore', 'desc');

    _.each(sortedUserRowData, ({userId,userData,totalItems,totalScoresPossible,fitScore,scoreDataByDimension,categoryScores}) => {

      const dimensionScoresRowParts = _.join(_.map(dimensionsScoredForProfile, (dimensionId) => {

        const userScoreDataForDimension = scoreDataByDimension[dimensionId];

        const { dimensionItems,dimensionTotalPossible,dimensionUserScore,dimensionAdjustedScore,dimensionPercentOfTotal } = userScoreDataForDimension;

        const dimensionPercent = categoryScores[getCategoryFromDimensionId(dimensionId).id].dimensions[dimensionId].percent;

        return `${dimensionPercent},${dimensionItems},${dimensionTotalPossible},${dimensionUserScore},${dimensionAdjustedScore},${dimensionPercentOfTotal}`;
      }));

      const categoryPercentsRowParts = _.join(_.map(TALENT_CATEGORIES, category => {
        return categoryScores[category.id].percent;
      }));

      assessmentScoresAsCSV += `\n${!userData ? userId : `${userData.firstName} ${userData.lastName}`},${totalItems},${totalItems * 7},${fitScore},${categoryPercentsRowParts},${dimensionScoresRowParts}`;
    })

    return assessmentScoresAsCSV;
  }

  fetchPublicUsers(userIds, callback){
    const getUser = userId => {
      return PublicUsersRef().doc(userId).get();
    }

    const userFetches = _.map(userIds, getUser);

    Promise.all(userFetches).then((data) => {
      callback(data);
    });
  }

  publicDataForUser(userId){
    console.log(this.state);
    console.log('searching ', this.state.userData, ' for ', userId);
    return _.find(this.state.userData || [], { _id: userId }) || null;
  }

  prepareReportWithCurrentOptions(){
    if(this.state.preparingReport){
      return;
    }

    this.setState({ preparingReport: true });

    const {
      selectedAssessment,
      selectedTalentProfile,
      includeOtherProfileAssessments,
    } = this.state;

    const profileWhereClauseArgs = includeOtherProfileAssessments ? ['status', '==', 'scored'] : ['assessmentConfig.profile', '==', selectedTalentProfile];

    AssessmentVersionsRef().doc(this.currentlySelectedAssessment().assessmentVersion).get().then(doc => {
      const assessmentVersion = unwrapDoc(doc);

      //fetch all assessments with critera for assessment
      AssessmentsRef().where('assessmentConfig.assessmentName', '==', selectedAssessment).where('status', '==', 'scored').where(...profileWhereClauseArgs).get().then(docs => {
        const assessments = unwrapDocs(docs);

        const realAssessments = excludeTestAssessments(assessments);

        console.log('found assessments', assessments);

        const scoredAssessments = _.map(realAssessments, assessment => {

          let assessmentScores;

          if(this.state.deprecatedScoring){
            //Deprecated - buggy scoring w/ reverse scored items
            assessmentScores = scoreAssessmentForExport(assessment.responses, assessmentVersion, selectedTalentProfile, '1');
          }
          else{
            //Fixed - reverse scored items scored correctly
            assessmentScores = scoreAssessmentForExport(assessment.responses, assessmentVersion, selectedTalentProfile);
          }

          return {
            assessment: assessment.assessmentConfig.assessmentName,
            originalProfile: assessment.assessmentConfig.profile,
            user: assessment.userId,
            scoredProfile: selectedTalentProfile,
            dimensionScores: assessmentScores.profileDimensionScores,
            categoryScores: assessmentScores.categoryScores,
            fitData: assessmentScores.fitData,
          }
        });

        console.log('assessments with scores: ', scoredAssessments);

        const usersToFetch = _.map(assessments, 'userId');

        console.log('fetching public user data for assessments...');
        this.fetchPublicUsers(usersToFetch, userDocs => {

          const userData = unwrapDocs(userDocs);

          this.setState({
            reportCSV: this.mapAssessmentScoresToCSV(scoredAssessments, userData),
            preparingReport: false,
          });
        });
      });
    });
  }

  renderExportActions(){
    const {
      selectedAssessment,
      selectedTalentProfile,
      preparingReport,
      reportCSV,
      recentlyCopied,
    } = this.state;

    if(!selectedAssessment || !selectedTalentProfile){
      return null;
    }

    return (
      <div className="export-actions">
        {!reportCSV &&
          <button disabled={preparingReport} onClick={() => { this.prepareReportWithCurrentOptions(); }} className="button grey-button">Prepare Export</button>
        }
        {reportCSV &&
          <CopyToClipboard options={{format: "text/plain"}} text={reportCSV} onCopy={() => { this.setState({ recentlyCopied: true }); setTimeout(() => { this.setState({ recentlyCopied: false }); }, 1000); }}>
            <button className="button primary">{recentlyCopied ? 'Copied!' : 'Copy CSV'}</button>
          </CopyToClipboard>
        }
      </div>
    )
  }

  render(){

    const {
      selectedAssessment
    } = this.state;

    if(!this.state.assessmentConfigs){
      return <p>Loading...</p>
    }

    return (
      <div className="page-section export-tool">
        {this.renderAssessmentConfigOption()}
        {selectedAssessment && this.renderExportDataOptions()}
        {selectedAssessment && this.state.selectedTalentProfile && this.renderDeprecatedScoringOption()}
        {selectedAssessment && this.renderExportActions()}
      </div>
    )
  }
}

function mapStateToProps(state){
  return {
    organizations: state.organizations.data
  }
}

export default connect(mapStateToProps, {})(AssessmentResultsExportTool);



// WEBPACK FOOTER //
// ./src/components/adminexport/exportTools/assessmentResults.js